/*global REACT_APP_API_BASE_URL_NEW:true*/
import request from "@/utils/request";

export async function getUsersAllowed({ page = 1, pageSize = 10, filter = "", filterId }) {
  page--;

  const SkipCount = page * pageSize;

  const params = {
    SkipCount,
    MaxResultCount: pageSize,
    FilterText: filter || undefined,
    FilterId: filterId,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/associated-users/allowed`, {
    method: "GET",
    params,
  });

  return result.data;
}

export async function switchUserCompany(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/associated-users/switch`, {
    method: "PUT",
    data,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function changeUserRole(data) {
  const result = await request(
    `${REACT_APP_API_BASE_URL_NEW}/api/core-service/associated-users/role/${data.userId}`,

    {
      method: "PUT",
      data,
    },
  );

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result;
}

export async function requestUserChange(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/associated-users/request-info-change`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }
  return result;
}

export async function getDrivers({ page = 1, pageSize = 10, filter = "", filterId, shipmentIds }) {
  page--;

  const SkipCount = page * pageSize;

  const params = {
    SkipCount,
    MaxResultCount: pageSize,
    FilterText: filter || undefined,
    FilterId: filterId,
    ShipmentIds: shipmentIds,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/associated-users/drivers`, {
    method: "GET",
    params,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}
